import { useWatch, type Path, type UseFormReturn } from 'react-hook-form'

/**
 * Hook to watch for form value updates.
 * This should be used instead of the form.watch function from react-hook-form's useForm.
 * This is required for React Compiler, since some functions of react-hook-form
 * does not yet support it properly.
 */
export function useFormWatch<
  TFormValues extends Record<string, any>,
  TKey extends Path<TFormValues>,
>(form: UseFormReturn<TFormValues>, name: TKey) {
  return useWatch({ control: form.control, name })
}
